var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{staticClass:"counter"},[_c('div',[_c('span',{staticClass:"label"},[_vm._v(" Compteur : "+_vm._s(_vm.node.attrs.count)+" ")]),_c('a',{staticClass:"button is-primary",on:{"click":_vm.increase}},[_vm._v(" +1 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }